import { smStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const ActionItemStyled = styled(Flex)`
  width: 100%;
  height: max-content;
  max-height: 60vh;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  overflow-y: auto;
  padding: 8px;

  ${smStyle} {
    width: max-content;
    height: max-content;
    max-height: 60vh;
  }

  .price-table-action--item {
    padding: 10px 8px;
    width: calc(100% - 16px);
    text-align: left;
    color: var(--color-text-1);
    font-size: 14px;
    font-weight: 500;
    align-items: center;
    display: flex;
    gap: 8px;
    box-sizing: border-box;

    ${smStyle} {
      width: 100%;
    }

    &-tag {
      ${smStyle} {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }

    &:hover {
      background-color: var(--color-neutral-2);
    }
  }
`
